"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
function UpdateNameMailFiles(_a) {
    var content = _a.content;
    return (React.createElement("div", null,
        React.createElement(pp_react_1.Text, { size: "xl3", className: "name-header" }, content.name.mail.files.header.title),
        React.createElement(pp_react_1.Text, { size: "md", className: "name-content" },
            content.name.mail.files.description,
            React.createElement(pp_react_1.Divider, { secondary: true }),
            React.createElement("ul", { className: "nameUnorderedListNone" },
                React.createElement("li", null,
                    React.createElement(pp_react_1.Text, { size: "md", medium: true }, content.name.address.line1)),
                React.createElement("li", null,
                    React.createElement(pp_react_1.Text, { size: "md" }, content.name.address.line2)),
                React.createElement("li", null,
                    React.createElement(pp_react_1.Text, { size: "md" }, content.name.address.line3)),
                React.createElement("li", null,
                    React.createElement(pp_react_1.Text, { size: "md" }, content.name.address.line4))))));
}
var mapStateToProps = function (_a) {
    var content = _a.content;
    return ({
        content: content,
    });
};
exports.default = react_redux_1.connect(mapStateToProps)(UpdateNameMailFiles);
